import React, { useEffect, useState } from 'react';
import Layout from 'Components/Layout';
import { Helmet } from 'react-helmet';
import CommonClasses from 'Styles/Common.module.css';
import TutorClasses from '../../Categories/addCategory/index.module.css';
import { useForm, Controller } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { Services } from 'Services';
import ReactLoading from 'react-loading';
import { BsCloudUpload } from 'react-icons/bs';
import GiftClasses from '../Gifts.module.css';
import { Success, Error, warningSwal } from 'Util/Toast';
import { useFileUpload } from 'Util/fileUpload';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const AddGifts = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [images, setImages] = useState([]);
    const [imagePreviews, setImagePreviews] = useState([]);
    const [categories, setCategories] = useState([]);
    const [bulkUploadFile, setBulkUploadFile] = useState(null);
    const [bulkUploadFileName, setBulkUploadFileName] = useState('');
    const [entryMode, setEntryMode] = useState('manual'); // 'manual' or 'file'
    const token = { Authorization: `token ${localStorage.getItem("token")}` };

    const {
        register,
        handleSubmit,
        setValue,
        getValues,
        control,
        formState: { errors },
    } = useForm();

    const { uploadMultipleWithLoading } = useFileUpload({
        allowedTypes: ["image/png", "image/jpeg", "image/webp"],
        maxSizeInMB: 10,
        folder: "Gifts"
    });

    const filehandleChange = async (event) => {
        const files = Array.from(event.target.files);
        if (files.length === 0) return;

        setLoading(true);
        try {
            await uploadMultipleWithLoading(
                files,
                (uploadedFiles) => {
                    // Success callback
                    const newUrls = uploadedFiles.map(f => f.fileUrl);

                    setImages((prev) => {
                        const updatedImages = [...prev, ...newUrls];
                        setValue('GiftImages', updatedImages);
                        return updatedImages;
                    });
                    setImagePreviews((prev) => [...prev, ...newUrls]);
                },

                (error) => {
                    console.error("Upload Error:", error);
                }
            );
        } finally {
            setLoading(false);
        }
    };


    const onSubmit = async (data) => {
        setLoading(true);
        try {
            const formData = {
                ...data,
                GiftImages: images,
                ProductID: data.ProductID,
                VendorID: data.VendorID,
                IsReturnable: Number(data.IsReturnable),
                IsCODAvailable: Number(data.IsCODAvailable),
                IsTrending: data.IsTrending ? 1 : 0,
            };

            const response = await Services.addGifts("POST", JSON.stringify(formData), token);
            if (response.Status === 1) {
                setLoading(false);
                navigate('/gifts');
                Success(response.Message);
            } else {
                setLoading(false);
            }
        } catch (error) {
            console.error('Error adding gift:', error);
            setLoading(false);
        }
    };

    const handleBulkUpload = async (event) => {
        const file = event.target.files[0];
        if (file) {
            setBulkUploadFile(file);
            setBulkUploadFileName(file.name);
        }
    };

    const uploadBulkFile = async () => {
        if (!bulkUploadFile) {
            Error('Please select a file for bulk upload');
            return;
        }

        setLoading(true);
        try {
            const formData = new FormData();
            formData.append('file', bulkUploadFile);

            const response = await Services.bulkUpload("POST", formData, token);
            if (response.status === 1) {
                Success(response.message);
                setBulkUploadFile(null);
                setBulkUploadFileName('');
                document.getElementById('bulkUpload').value = '';
                navigate(-1);
            } else {
                Error(response.message || 'Bulk upload failed');
            }
        } catch (error) {
            console.error('Error in bulk upload:', error);
            Error('Error uploading file');
        } finally {
            setLoading(false);
        }
    };

    const fileuploadDesign = (
        <div className={TutorClasses["add-item"]} onClick={() => document.getElementById("image").click()}>
            <div className={TutorClasses['upload-image']}>
                {imagePreviews.map((preview, index) => (
                    <img key={index} src={preview} alt="Selected" className={TutorClasses['uploaded-coupon-image']} />
                ))}
                {!imagePreviews.length && (
                    <div className={TutorClasses['add-item']}>
                        <BsCloudUpload className={TutorClasses['upload-icon']} />
                        <h5>Drag Your Files here</h5>
                        <p>(Only *.jpeg, *.png will be accepted)</p>
                    </div>
                )}
                <input type="file" id="image" onChange={filehandleChange} multiple style={{ display: 'none' }} />
            </div>
        </div>
    );

    const fetchCategories = () => {
        setLoading(true);
        Services.getCategories("POST", null, token)
            .then((response) => {
                setLoading(false);
                if (response.Status === 1) {
                    setCategories(response.Categories);
                } else if (response.Status === 0) {
                    warningSwal("Warning", response.Message);
                }
            })
            .catch((err) => {
                setLoading(false);
                alert("Something went wrong. Please try again.");
                console.error(err);
            });
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    const validateOfferPrice = (offerPrice) => {
        const price = getValues('Price');
        return parseFloat(offerPrice) <= parseFloat(price) || 'Offer price should not be greater than the price';
    };

    return (
        <Layout Active={'Gifts'}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Create Gift</title>
            </Helmet>
            <div className={CommonClasses['Container']}>
                <div className={CommonClasses["control-btns"]}>
                    <button className={CommonClasses["button"]} onClick={() => navigate(-1)}>Back</button>
                </div>
                <div className={TutorClasses['wrapper']} data-aos="zoom-in-down">
                    <h2 className={TutorClasses['main-header']}>Create Gift</h2>

                    {/* Entry Mode Toggle */}
                    <div style={{ marginBottom: '20px', textAlign: 'center' }}>
                        <div style={{ display: 'inline-flex', border: '1px solid #ddd', borderRadius: '8px', overflow: 'hidden' }}>
                            <button
                                type="button"
                                onClick={() => setEntryMode('manual')}
                                style={{
                                    padding: '10px 20px',
                                    border: 'none',
                                    backgroundColor: entryMode === 'manual' ? '#007bff' : '#f8f9fa',
                                    color: entryMode === 'manual' ? 'white' : '#333',
                                    cursor: 'pointer',
                                    fontWeight: entryMode === 'manual' ? 'bold' : 'normal'
                                }}
                            >
                                Manual Entry
                            </button>
                            <button
                                type="button"
                                onClick={() => setEntryMode('file')}
                                style={{
                                    padding: '10px 20px',
                                    border: 'none',
                                    backgroundColor: entryMode === 'file' ? '#007bff' : '#f8f9fa',
                                    color: entryMode === 'file' ? 'white' : '#333',
                                    cursor: 'pointer',
                                    fontWeight: entryMode === 'file' ? 'bold' : 'normal'
                                }}
                            >
                                File Upload
                            </button>
                        </div>
                    </div>

                    {/* Manual Entry Form */}
                    {entryMode === 'manual' && (
                        <form className={TutorClasses["form"]} onSubmit={handleSubmit(onSubmit)}>
                            <div className={TutorClasses['form-control']}>
                                <label htmlFor="GiftName">Gift Name</label>
                                <input type='text' {...register('GiftName', { required: true })} />
                                {errors.GiftName && <p className={GiftClasses["error-message"]}>Gift Name is required</p>}
                            </div>

                            <div className={TutorClasses['form-control']}>
                                <label htmlFor="ProductID">ProductID</label>
                                <input type='text' {...register('ProductID', { required: true })} />
                                {errors.ProductID && <p className={GiftClasses["error-message"]}>ProductID is required</p>}
                            </div>

                            <div className={TutorClasses['form-control']}>
                                <label htmlFor="VendorID">VendorID</label>
                                <input type='text' {...register('VendorID', { required: true })} />
                                {errors.VendorID && <p className={GiftClasses["error-message"]}>VendorID is required</p>}
                            </div>

                            <div className={TutorClasses['file-upload-wrapper']}>
                                <header>
                                    <h3>
                                        Upload Gift Images<span className="important">*</span>
                                    </h3>
                                </header>
                                <div className={TutorClasses["upload-image"]} required>
                                    {fileuploadDesign}
                                </div>
                            </div>

                            <div className={TutorClasses['form-control']}>
                                <label htmlFor="Price">Price</label>
                                <input type='number' step="0.01" {...register('Price', { required: true })} />
                                {errors.Price && <p className={GiftClasses["error-message"]}>Price is required</p>}
                            </div>

                            <div className={TutorClasses['form-control']}>
                                <label htmlFor="OfferPrice">Offer Price</label>
                                <input type='number' step="0.01" {...register('OfferPrice', {
                                    required: true,
                                    validate: validateOfferPrice
                                })} />
                                {errors.OfferPrice && <p className={GiftClasses["error-message"]}>{errors.OfferPrice.message}</p>}
                            </div>

                            <div className={TutorClasses['form-control']}>
                                <label htmlFor="GiftDescription">Gift Description</label>
                                <textarea {...register('GiftDescription', { required: true })} />
                                {errors.GiftDescription && <p className={GiftClasses["error-message"]}>Gift Description is required</p>}
                            </div>

                            <div className={TutorClasses['form-control']}>
                                <label htmlFor="Material">Material</label>
                                <input type='text' {...register('Material', { required: true })} />
                                {errors.Material && <p className={GiftClasses["error-message"]}>Material is required</p>}
                            </div>

                            <div className={TutorClasses['form-control']}>
                                <label htmlFor="Capacity">Capacity</label>
                                <input type='text' {...register('Capacity', { required: true })} />
                                {errors.Capacity && <p className={GiftClasses["error-message"]}>Capacity is required</p>}
                            </div>

                            <div className={TutorClasses['form-control']}>
                                <label htmlFor="ProductDimension">Product Dimension</label>
                                <input type='text' {...register('ProductDimension', { required: true })} />
                                {errors.ProductDimension && <p className={GiftClasses["error-message"]}>Product Dimension is required</p>}
                            </div>

                            <div className={TutorClasses['form-control']}>
                                <label htmlFor="TopDiameter">Top Diameter</label>
                                <input type='text' {...register('TopDiameter', { required: true })} />
                                {errors.TopDiameter && <p className={GiftClasses["error-message"]}>Top Diameter is required</p>}
                            </div>

                            <div className={TutorClasses['form-control']}>
                                <label htmlFor="PackageInclude">Package Include</label>
                                <input type='text' {...register('PackageInclude', { required: true })} />
                                {errors.PackageInclude && <p className={GiftClasses["error-message"]}>Package Include is required</p>}
                            </div>

                            <div className={TutorClasses['form-control']}>
                                <label htmlFor="QuantityAvailable">Quantity Available</label>
                                <input type='number' {...register('QuantityAvailable', { required: true })} />
                                {errors.QuantityAvailable && <p className={GiftClasses["error-message"]}>Quantity Available is required</p>}
                            </div>

                            <div className={TutorClasses['form-control']}>
                                <label htmlFor="IsReturnable">Is Returnable</label>
                                <Controller
                                    name="IsReturnable"
                                    control={control}
                                    defaultValue=""
                                    rules={{ required: true }}
                                    render={({ field }) => (
                                        <FormControl fullWidth>
                                            <Select
                                                {...field}
                                                displayEmpty
                                                error={!!errors.IsReturnable}
                                            >
                                                <MenuItem value="" disabled>Select option</MenuItem>
                                                <MenuItem value="1">Yes</MenuItem>
                                                <MenuItem value="0">No</MenuItem>
                                            </Select>
                                        </FormControl>
                                    )}
                                />
                                {errors.IsReturnable && <p className={GiftClasses["error-message"]}>Is Returnable is required</p>}
                            </div>

                            <div className={TutorClasses['form-control']}>
                                <label htmlFor="IsCODAvailable">Is COD Available</label>
                                <Controller
                                    name="IsCODAvailable"
                                    control={control}
                                    defaultValue=""
                                    rules={{ required: true }}
                                    render={({ field }) => (
                                        <FormControl fullWidth>
                                            <Select
                                                {...field}
                                                displayEmpty
                                                error={!!errors.IsCODAvailable}
                                            >
                                                <MenuItem value="" disabled>Select option</MenuItem>
                                                <MenuItem value="1">Yes</MenuItem>
                                                <MenuItem value="0">No</MenuItem>
                                            </Select>
                                        </FormControl>
                                    )}
                                />
                                {errors.IsCODAvailable && <p className={GiftClasses["error-message"]}>Is COD Available is required</p>}
                            </div>

                            <div className={TutorClasses['form-control']}>
                                <label htmlFor="CategoryID">Category Name</label>
                                <Controller
                                    name="CategoryIDs"
                                    control={control}
                                    defaultValue={[]}
                                    render={({ field: { onChange, value } }) => (
                                        <Autocomplete
                                            multiple
                                            options={categories}
                                            disableCloseOnSelect
                                            getOptionLabel={(option) => option.CategoryName}
                                            onChange={(event, newValue) => {
                                                const selectedOptions = newValue.map(option => option.CategoryID);
                                                onChange(selectedOptions);
                                            }}
                                            value={categories.filter(cat => value.includes(cat.CategoryID))}
                                            renderOption={(props, option, { selected }) => (
                                                <li {...props}>
                                                    <Checkbox
                                                        icon={icon}
                                                        checkedIcon={checkedIcon}
                                                        style={{ marginRight: 8 }}
                                                        checked={selected}
                                                    />
                                                    {option.CategoryName}
                                                </li>
                                            )}
                                            renderInput={(params) => (
                                                <TextField {...params} label="Categories" placeholder="Select Categories" sx={{ width: '100%' }} />
                                            )}
                                        />
                                    )}
                                />
                                {errors.CategoryIDs && <p className={GiftClasses["error-message"]}>Category is required</p>}
                            </div>

                            <div className={TutorClasses['form-control']}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <input
                                        type="checkbox"
                                        id="IsTrending"
                                        {...register('IsTrending')}
                                        style={{
                                            width: '18px',
                                            height: '18px',
                                            cursor: 'pointer'
                                        }}
                                    />
                                    <label htmlFor="IsTrending" style={{ cursor: 'pointer', margin: 0 }}>
                                        Make it Trending
                                    </label>
                                </div>
                                <p style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
                                    Check this box to mark the gift as trending
                                </p>
                            </div>

                            <button disabled={loading}>
                                {loading ? (
                                    <ReactLoading color="green" type="spokes" height={30} width={30} />
                                ) : (
                                    'Submit'
                                )}
                            </button>
                        </form>
                    )}

                    {/* File Upload Section */}
                    {entryMode === 'file' && (
                        <div className={TutorClasses['form-control']}>
                            <label htmlFor="bulkUpload">Upload Gift File</label>
                            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                <input
                                    type="file"
                                    id="bulkUpload"
                                    onChange={handleBulkUpload}
                                    style={{ flex: 1 }}
                                    accept=".xlsx,.xls,.csv"
                                />
                                {bulkUploadFile && (
                                    <button
                                        type="button"
                                        onClick={uploadBulkFile}
                                        disabled={loading}
                                        style={{
                                            padding: '8px 16px',
                                            backgroundColor: '#007bff',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '4px',
                                            cursor: loading ? 'not-allowed' : 'pointer'
                                        }}
                                    >
                                        {loading ? 'Uploading...' : 'Upload'}
                                    </button>
                                )}
                            </div>
                            {bulkUploadFileName && (
                                <p style={{ marginTop: '5px', fontSize: '14px', color: '#666' }}>
                                    Selected file: {bulkUploadFileName}
                                </p>
                            )}
                            <p style={{ marginTop: '10px', fontSize: '12px', color: '#888' }}>
                                Supported formats: .xlsx, .xls, .csv
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </Layout>
    );
};

export default AddGifts;
